import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';

interface WidgetActionsProps {
  onRemove: () => void;
  onRefresh?: () => void;
  onAddToChat?: (widgetId: string) => void;
  onPopout?: (widgetId: string) => void;
  widgetId?: string;
  hideDragIcon?: boolean;
}

export const WidgetActions: React.FC<WidgetActionsProps> = ({
  onRemove,
  onRefresh,
  onAddToChat,
  onPopout,
  widgetId,
  hideDragIcon = false,
}) => {
  const menuRef = useRef<Menu>(null);

  const menuItems: MenuItem[] = [
    ...(onRefresh
      ? [
          {
            label: 'Refresh Widget',
            icon: 'pi pi-refresh',
            command: onRefresh,
            className: 'text-blue-500',
          },
        ]
      : []),
    ...(widgetId && onPopout
      ? [
          {
            label: 'Pop Out',
            icon: 'pi pi-external-link',
            command: () => onPopout(widgetId),
            className: 'text-blue-500',
          },
        ]
      : []),
    {
      label: 'Remove Widget',
      icon: 'pi pi-trash',
      command: onRemove,
      className: 'text-red-500',
    },
    ...(widgetId &&
    onAddToChat &&
    widgetId !== undefined &&
    onAddToChat !== null
      ? [
          {
            label: 'Add to Chat',
            icon: 'pi pi-microchip-ai',
            className: 'text-blue-500',
            style: { color: 'var(--primary-color)' },
            command: () => onAddToChat(widgetId),
          },
        ]
      : []),
  ];

  return (
    <div
      className="align-items-center flex gap-2"
      data-testid={`widget-actions${widgetId ? `-${widgetId}` : ''}`}
      style={{ paddingRight: '0' }}
    >
      {/* Todo: remove this icon */}
      {!hideDragIcon && (
        <span
          className="pi pi-arrows-alt drag-handler hover-icon cursor-pointer"
          style={{ color: 'var(--primary-color)' }}
          title="Move Widget"
          data-pr-tooltip="Move Widget"
        />
      )}
      <span
        className="pi pi-ellipsis-v cursor-pointer"
        style={{ color: 'var(--primary-color)' }}
        title="Widget Actions"
        data-pr-tooltip="Widget Actions"
        onClick={(e) => {
          e.stopPropagation();
          menuRef.current?.toggle(e);
        }}
      />
      <Menu ref={menuRef} model={menuItems} popup />
    </div>
  );
};
